import { Component, effect, input, output } from '@angular/core';
import { ImageViewerComponent } from "../image-viewer/image-viewer.component";
import { ButtonClickEvent, CacFormBuilderComponent, formBuilder, CacBottomControlsComponent } from "@controladad/ng-base";
import { formControl, Validators } from '@al00x/forms';
import { LocationEntity, LocationUpdate, TagStatus } from '@admin/core/models';
import { TagStatusValues } from '@admin/shared/data/static.data';
import { isChangingTagStatusValid } from '@admin/shared/helpers/utility.helper';

export interface LocationDetailsSubmitEvent {
  model: LocationUpdate;
  e: ButtonClickEvent;
}

@Component({
  selector: 'app-location-details',
  imports: [ImageViewerComponent, CacFormBuilderComponent, CacBottomControlsComponent],
  templateUrl: './location-details.component.html',
})
export class LocationDetailsComponent {
  location = input<LocationEntity | undefined>(undefined);
  submit = output<LocationDetailsSubmitEvent>();

  form = formBuilder({
    cols: 2,
    inputs: {
      name: {
        control: formControl<string>(undefined),
        label: 'نام',
      },
      parentName: {
        control: formControl<string>(undefined),
        label: 'نام مکان والد',
      },
      tagSerial: {
        control: formControl<string>(undefined),
        label: 'سریال تگ',
      },
      tagStatus: {
        control: formControl<TagStatus>(undefined, Validators.required),
        label: 'وضعیت تگ',
        type: 'select',
        items: TagStatusValues,
      },
      tagImagePath: {
        control: formControl<string>(undefined),
        hidden: true,
      },
      description: {
        control: formControl<string>(undefined),
        label: 'توضیحات',
        type: 'textarea',
      },
    },
    onInit: () => {
      this.form.setReadonly(true);
      this.form.setReadonly(false, 'tagStatus', 'tagSerial');
    },
  });

  constructor() {
    effect(() => {
      const location = this.location();
      if (location) {
        this.form.setValue({
          name: location.name,
          parentName: location.parentName ?? '',
          tagSerial: location.tagSerial ?? '',
          tagStatus: location.tagStatus,
          tagImagePath: location.tagImagePath,
          description: location.description,
        });
      } else {
        this.form.reset();
      }
    });
  }

  onSubmit(e: ButtonClickEvent) {
    const location = this.location();
    if (!location) return;
    const values = this.form.getValue();
    if (!values) return;
    const tagStatus = values.tagStatus;

    if (!isChangingTagStatusValid(location.tagStatus, tagStatus, true)) return;

    this.submit.emit({ model: { tagStatus, tagSerial: values.tagSerial }, e });
  }
}
